import axiosInstant from "../axiosInstant";
import { encodeId, decodeId} from "../hash";
export async function getSingaleData(id,lotNumber) {
  // alert(id)
  const response = await axiosInstant
    .get(
      `lot/details?auction_id=${id}&lot_number=${lotNumber=== undefined ? 1:lotNumber}`
    )
    .then((res) => {

      return res.data;
    })
    .catch((error) => {
      console.log(error.response.data);
    });
  return response;
}



export async function postInequired(ArrayData) {

      const response = await axiosInstant
      .post(
        `private-sales/inquire`,ArrayData
      )
      .then((res) => {

        return res.data;
      })
      .catch((error) => {
        return error.response.data;
      });
    return response;

  
}





export async function getPrivateSingleData(id) {
  const response = await axiosInstant
    .get(
      `private-sales/byId/${decodeId(id)}`
    )
    .then((res) => {

      return res.data.msg;
    })
    .catch((error) => {
      console.log(error.response.data);
    });
  return response;
}






